import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=29a20b42&lang=pug"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"
import style0 from "./Final.vue?vue&type=style&index=0&id=29a20b42&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports